import * as React from 'react';

import GalleryModalAsset from 'components/gallery-modal/gallery-modal-asset/GalleryModalAsset';

import './content-gallery-asset-overlay.scss';

import type {
  GalleryModalItem
} from 'types';

type Props = {
  contents: React.ReactNode,
  selectedItem: GalleryModalItem,
  currentPosition: number
};

const ContentGalleryAssetOverlay: React.FunctionComponent<Props> = ({
  contents,
  selectedItem,
  currentPosition
}: Props) => (
  <div className="content-gallery-asset-overlay">
    <GalleryModalAsset
      selectedItem={selectedItem}
      currentPosition={currentPosition}
    />
    <div className="content-gallery-asset-overlay__contents">
      {contents}
    </div>
  </div>
);

export default ContentGalleryAssetOverlay;
